var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import BrandHeader from "../brandHeader/brandHeader";
import "../jsQuestionnaireHeader/jsQuestionnaireHeader.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogoutAction } from "../../../redux/actions/authentication";
import { updateNeedsQuestionnaire } from "../../../redux/actions/dashboard";
/**
 * The Job Seeker Questionnaire Header.
 * This is the top most part in the questionnaire which is same for all the questionnaire for the job seeker.
 * The headings are constructed which are then assigned their Title, content, progressive bar width.
 */
export default function ObligationsQuestionnaireHeader(props) {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    // Get the viewing_username (the jobseeker being viewed by the adviser)
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    var handleLogout = function () {
        navigate("/login");
        dispatch(LogoutAction());
    };
    var handleSkip = function () {
        dispatch(updateNeedsQuestionnaire(false));
        if (viewing_username) {
            navigate("/dashboard", { state: { viewUser: viewing_username } });
        }
        else {
            navigate("/dashboard");
        }
    };
    var progressBar = {
        width: "".concat(props.width),
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex justify-between items-center" }, { children: [_jsx(BrandHeader, {}), _jsxs("div", __assign({ className: "flex flex-row gap-4" }, { children: [_jsx("a", __assign({ onClick: handleSkip, className: "logout-link cursor-pointer", style: {
                                    color: "var(--primary)",
                                    fontWeight: 600,
                                    textDecoration: "none",
                                    transition: "opacity 0.2s"
                                }, onMouseEnter: function (e) { return e.currentTarget.style.opacity = "0.8"; }, onMouseLeave: function (e) { return e.currentTarget.style.opacity = "1"; } }, { children: "Skip" })), _jsx("a", __assign({ onClick: handleLogout, className: "logout-link cursor-pointer", style: {
                                    color: "var(--primary)",
                                    fontWeight: 600,
                                    textDecoration: "none",
                                    transition: "opacity 0.2s"
                                }, onMouseEnter: function (e) { return e.currentTarget.style.opacity = "0.8"; }, onMouseLeave: function (e) { return e.currentTarget.style.opacity = "1"; } }, { children: "Logout" }))] }))] })), _jsxs("div", __assign({ className: "questionnaire-sticky-header" }, { children: [_jsxs("div", __assign({ className: "m-top" }, { children: [_jsxs("div", __assign({ className: "flex justify-between items-baseline" }, { children: [_jsx("p", __assign({ className: "heading capitalize font-medium not-italic set-line-height" }, { children: "Questionnaire" })), props.width && (_jsxs("p", __assign({ className: "progress-percentage font-medium not-italic set-line-height" }, { children: [props.width, " complete"] })))] })), props.width && (_jsx("div", __assign({ className: "slider" }, { children: _jsx("div", { className: "inner-slider inner-slider-w ".concat(props.classname), style: progressBar }) })))] })), _jsxs("div", __assign({ className: "questionnaire-heading-m" }, { children: [_jsx("p", __assign({ className: "questionnaire-heading capitalize font-medium not-italic set-line-height justify-center" }, { children: props.title })), _jsx("p", __assign({ className: "questionnaire-heading-content questionnaire-heading-content--pinned font-medium not-italic set-line-height" }, { children: props.content }))] }))] })), props.content && (_jsx("p", __assign({ className: "questionnaire-heading-content questionnaire-heading-content--unpinned font-medium not-italic set-line-height" }, { children: props.content })))] }));
}
